var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-loading-state"},[_c('div',{staticClass:"wizard-loading-content"},[_c('div',{staticClass:"wizard-spinner"}),_c('div',{staticClass:"wizard-loading-text"},[_c('h2',{staticClass:"wizard-loading-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"wizard-loading-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }